<template>
  <div>
    <question-renderer
      :question="src"
      :indicator="indicator"
    ></question-renderer>

    <div class="puzzle-zone">
      <div class="wordsearch_grid">
        <div class="d-flex" v-for="(rowV, row) in sizeInt" :key="`row_${row}`">
          <div
            class="d-flex justify-center"
            v-for="(colV, col) in sizeInt"
            :key="`${row}_${col}`"
          >
            <div
              :class="letterTileClasses(col, row)"
              :data-x="col"
              :data-y="row"
              class="d-flex"
              @mousedown.prevent="wordSelectStart"
              @mouseup="wordSelectUpdate"
              @mousemove="wordSelectUpdate"
              @touchstart.prevent="wordSelectStart"
              @touchend="wordSelectUpdate"
              @touchmove="wordSelectUpdate"
              style="position: relative"
            >
              <svg width="100%" height="100%" viewBox="0 -1 24 24">
                <text
                  x="50%"
                  dominant-baseline="middle"
                  y="50%"
                  text-anchor="middle"
                >
                  {{ gridVal(col, row) }}
                </text>
              </svg>
            </div>
            <!-- <div
                v-for="(wordLineData, wordLineIndex) in wordListForTile(col, row)"
                :key="`${row}_${col}_${wordLineIndex}`"
                :class="wordLineClasses(wordLineData)"
            ></div>-->
          </div>
        </div>
      </div>
    </div>

    <v-list dense outlined rounded class="mt-3">
      <v-subheader>รายการคำตอบ</v-subheader>
      <template v-for="(ans, idx) of wordList">
        <v-list-item :key="`ans_user_${idx}`">
          <v-list-item-title>{{ ans.text }}</v-list-item-title>
          <v-list-item-action v-if="!readOnly">
            <v-btn icon small @click="removeWord(ans, idx)">
              <v-icon small color="error">far fa-times</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="idx < wordList.length - 1"
          :key="`divider_user_wordList_${idx}`"
        ></v-divider>
      </template>
    </v-list>

    <div id="correct-block" class="mt-4">
      <template v-if="showCorrectAnswer == true">
        <div class="title">เฉลย</div>
        <div class="puzzle-zone mt-3">
          <div class="wordsearch_grid">
            <div
              class="d-flex"
              v-for="(rowV, row) in sizeInt"
              :key="`row_${row}`"
            >
              <div
                class="d-flex justify-center"
                v-for="(colV, col) in sizeInt"
                :key="`${row}_${col}`"
              >
                <div
                  :class="letterTileClassesForCorrect(col, row)"
                  :data-x="col"
                  :data-y="row"
                  class="d-flex"
                  style="position: relative"
                >
                  <svg width="100%" height="100%" viewBox="0 -1 24 24">
                    <text
                      x="50%"
                      dominant-baseline="middle"
                      y="50%"
                      text-anchor="middle"
                    >
                      {{ gridVal(col, row) }}
                    </text>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-list dense outlined class="mt-3" rounded>
          <v-subheader>รายการคำตอบ</v-subheader>
          <v-divider></v-divider>
          <template v-for="(ans, idx) of correctAnswer.correctPuzzle.wordList">
            <v-list-item :key="`ans_correct_${idx}`">
              <v-list-item-title>{{ ans.text }}</v-list-item-title>
            </v-list-item>
            <v-divider
              v-if="idx < correctAnswer.correctPuzzle.wordList.length - 1"
              :key="`divider_correct_wordList_${idx}`"
            ></v-divider>
          </template>
        </v-list>
      </template>
    </div>

    <v-overlay :value="overlay">
      <pinch-zoom v-bind:properties="myProperties">
        <img :src="imgPinch" />
      </pinch-zoom>
      <v-btn class="ma-2 btn-close" fab dark small @click="overlay = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import EventBus from "@/event-bus";
import PinchZoom from "vue-pinch-zoom";
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  components: {
    QuestionRenderer,
    PinchZoom,
  },
  data: () => ({
    answer: {},
    overlay: false,
    myProperties: {
      overflow: "visible",
    },
    imgPinch: null,
    letterGrid: [],
    selectedRange: {
      start: undefined,
      end: undefined,
    },
    guess: [],
    words: [],
    backwards: false,
    letterGrid: [[]],
    usedTiles: [],
    wordList: [],
    debugEnabled: false,
    usedTilesCorrect: [],
  }),
  watch: {
    overlay(val) {
      if (val === false) {
        this.lastDrag = null;
      }
    },
    wordList: {
      deep: true,
      handler: function (val) {
        const data = {
          answer: val,
        };
        // console.log(data);
        this.$emit("interact", data);
      },
    },
    showCorrectAnswer(val) {
      if (val) {
        this.showCorrect();
      }
    },
  },
  computed: {
    guessedWord() {
      return this.guess.map((l) => this.gridVal(l.x, l.y)).join("");
    },
    sizeInt() {
      return this.src.puzzleGridSize;
    },
    fillAllTextBox() {
      let idx = this.activeWord.indexOf("");
      if (idx === -1) {
        return true;
      }
      return false;
    },
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correctPuzzle != null
      ) {
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  mounted() {
    this.answer = {};
    this.init();
  },
  methods: {
    init() {
      // console.log("init multiple q", this.src);
      this.usedTiles = [];
      this.letterGrid = this.src.puzzleGridQuestion;

      if (this.userAnswer != null) {
        this.answer = this.userAnswer;

        // redraw ui
        this.wordList = this.answer;
        for (let word of this.wordList) {
          let positions = this.$gameUtil.gridPositions(word.data);
          // add tile used
          for (let pos of positions) {
            this.usedTiles.push({
              x: pos.x,
              y: pos.y,
            });
          }
        }
      }
    },
    showCorrect() {
      // console.log(this.showCorrectAnswer);
      // redraw ui
      // place correct tiles
      for (let word of this.correctAnswer.correctPuzzle.wordList) {
        let positions = this.$gameUtil.gridPositions(word.data);
        // console.log(word)
        let idx = 0;
        for (let pos of positions) {
          for (let pos of positions) {
            this.usedTilesCorrect.push({
              x: pos.x,
              y: pos.y,
            });
          }
        }
      }

      this.$nextTick(() => {
        this.$vuetify.goTo("#correct-block");
      });
    },
    getAnswer() {
      this.answer = this.wordList;
      return this.answer;
    },
    removeWord(ans, idxWord) {
      // remove found tiles
      // console.log(ans);
      let positions = this.$gameUtil.gridPositions(ans.data);

      for (let position of positions) {
        let idx = this.usedTiles.findIndex(
          (pos) => pos.x == position.x && pos.y == position.y
        );
        if (idx !== -1) {
          this.usedTiles.splice(idx, 1);
        }
      }
      this.wordList.splice(idxWord, 1);
    },

    //#region game methods
    gridVal(x, y) {
      if (typeof this.letterGrid[y] !== "undefined") {
        if (typeof this.letterGrid[y][x] !== "undefined") {
          return this.letterGrid[y][x];
        }
      }
      return "";
    },
    letterTileClasses(x, y) {
      const classes = ["letter-tile"];
      if (this.isTileHighlighted(x, y)) {
        classes.push("letter-tile-highlighted");
      }

      if (this.isTileAFoundWordTile(x, y)) {
        classes.push("letter-tile-found");
      }
      return classes;
    },
    letterTileClassesForCorrect(x, y) {
      const classes = ["letter-tile"];
      let usedTile = this.usedTilesCorrect.find(
        (pos) => pos.x == x && pos.y == y
      );
      if (usedTile != null) {
        classes.push("green lighten-5");
      }
      return classes;
    },
    isTileAFoundWordTile(x, y) {
      for (let i = 0; i < this.usedTiles.length; i += 1) {
        if (this.usedTiles[i].x === x && this.usedTiles[i].y === y) {
          return true;
        }
      }
      return false;
    },
    isTileHighlighted(x, y) {
      if (this.selectedRange.start && this.selectedRange.end) {
        const r = this.selectedRange;
        const minX = Math.min(r.start.x, r.end.x);
        const maxX = Math.max(r.start.x, r.end.x);
        const minY = Math.min(r.start.y, r.end.y);
        const maxY = Math.max(r.start.y, r.end.y);
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          // in range. If X or Y are equal then it's a straight line, otherwise
          // Work out diagonal logic.
          return (
            r.start.x === r.end.x ||
            r.start.y === r.end.y ||
            Math.abs(r.start.x - x) === Math.abs(r.start.y - y)
          );
        }
      }
      return false;
    },
    // wordListForTile(x, y) {
    //   return this.wordList.filter(
    //     (wordLine) => wordLine.x === x && wordLine.y === y
    //   );
    // },
    wordLineClasses(wordLine) {
      const classes = [
        "word-strike",
        "word-strike-direction-" + wordLine.direction,
        "word-strike-length-" + wordLine.length,
      ];
      // Odd directions are diagonal
      if (wordLine.direction % 2 === 1) {
        classes.push("word-strike-diagonal");
      }
      return classes;
    },
    wordSelectStart(event) {
      const touchedElement = event.target.closest("div.letter-tile");
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        this.selectedRange.start = {
          x: parseInt(touchedElement.dataset.x, 10),
          y: parseInt(touchedElement.dataset.y, 10),
        };
        return true;
      }
      return false;
    },
    wordSelectUpdate(event) {
      // We never started selecting, bail early.
      if (this.selectedRange.start === undefined) {
        return false;
      }
      let touch = event;
      if (event.type.indexOf("touch") === 0) {
        touch = event.changedTouches.item(0);
      }
      const tEl = document.elementFromPoint(touch.clientX, touch.clientY);
      if (!tEl) {
        return false;
      }
      const touchedElement = tEl.closest("div.letter-tile");
      if (
        touchedElement &&
        touchedElement.dataset &&
        touchedElement.dataset.x
      ) {
        const x = parseInt(touchedElement.dataset.x, 10);
        const y = parseInt(touchedElement.dataset.y, 10);
        const dx = Math.abs(x - this.selectedRange.start.x);
        const dy = Math.abs(y - this.selectedRange.start.y);
        // Verify the end is valid.
        // If dy (change in y) or dx (change in x) is zero, then it is horizontal/vertcal == OK.
        // Or if dx === dy, then it is diagonal.
        if ((dy === 0 && dx > 0) || (dx === 0 && dy > 0) || dx === dy) {
          this.selectedRange.end = { x, y };
          // If it's mouseup, then we finished the dragging a range
          if (event.type === "mouseup" || event.type === "touchend") {
            // console.log(JSON.stringify(this.selectedRange)); // eslint-disable-line no-console
            this.guess = [];
            // Build guess!
            const sx = this.selectedRange.start.x;
            const sy = this.selectedRange.start.y;
            const ex = this.selectedRange.end.x;
            const ey = this.selectedRange.end.y;
            // 0 = up, 1 = up-right, 2 = right, 3 = down-right, 4 = down
            // 5 = down-left, 6 = left, 7 = up-left
            var direction = 0;
            if (dx === 0) {
              // Vertical
              const step = ey > sy ? 1 : -1;
              for (let i = sy; step > 0 ? i <= ey : i >= ey; i += step) {
                this.guess.push({ x: sx, y: i });
              }
              direction = step > 0 ? 4 : 0;
            } else if (dy === 0) {
              // Horizontal
              const step = ex > sx ? 1 : -1;
              for (let i = sx; step > 0 ? i <= ex : i >= ex; i += step) {
                this.guess.push({ x: i, y: sy });
              }
              direction = step > 0 ? 2 : 6;
            } else {
              // Diagonal
              const stepX = ex > sx ? 1 : -1;
              const stepY = ey > sy ? 1 : -1;
              for (
                let iX = sx, iY = sy;
                (stepY > 0 ? iY <= ey : iY >= ey) ||
                (stepX > 0 ? iX <= ex : iX >= ex);
                iY += stepY, iX += stepX
              ) {
                this.guess.push({ x: iX, y: iY });
              }
              direction = stepX > 0 ? (stepY > 0 ? 3 : 1) : stepY > 0 ? 5 : 7;
            }

            // check read only
            if (this.readOnly) {
              this.resetSelectedRange();
              return false;
            }

            // check exist
            let exist = this.wordList.findIndex(
              (x) => x.text == this.guessedWord
            );

            if (exist === -1) {
              this.usedTiles.push(...this.guess);
              //console.log(this.usedTiles);
              const newWordLine = {
                text: this.guessedWord,
                data: {
                  x: sx,
                  y: sy,
                  length: this.guessedWord.length,
                  direction,
                },
              };
              this.wordList.push(newWordLine);

              if (this.debugEnabled) {
                console.log(
                  "Found Word:",
                  this.guessedWord,
                  sx,
                  sy,
                  newWordLine
                ); // eslint-disable-line no-console
              }
            }
            // Gesture complete, reset the range.
            this.resetSelectedRange();
          }
        } else if (event.type === "mouseup" || event.type === "touchend") {
          // Verify failed, reset range (only if at the end of a gesture)
          this.resetSelectedRange();
        } else {
          this.selectedRange.end = undefined;
        }
      } else if (event.type === "mouseup" || event.type === "touchend") {
        // End was "null" or had no x/y. Reset.
        this.resetSelectedRange();
      } else {
        this.selectedRange.end = undefined;
      }
      return true;
    },
    resetSelectedRange() {
      this.selectedRange = {
        start: undefined,
        end: undefined,
      };
    },
    //#endregion
  },
};
</script>

<style lang="scss" scoped>
.puzzle-zone ::v-deep div.wordsearch_grid {
  min-width: calc(90vw - 50px);
  background: #fff;

  @media screen and (min-width: 100vh) {
    min-width: calc(90vh - 50px);
  }

  > div {
    > div {
      border: 1px solid #d3d3d3;
      padding: 0;

      &:not(:last-child) {
        border-right-width: 0 !important;
      }

      > div {
        > svg {
          line-height: 1 !important;
          font-weight: normal !important;
        }
      }
    }

    &:not(:last-child) {
      > div {
        border-bottom-width: 0 !important;
      }
    }
  }
}

.letter-tile {
  padding: 0 0;
  cursor: pointer;
  //   svg {
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     line-height: 0;
  //     width: 100%;
  //     // fill: $body-color;
  //   }

  transition: background ease-in 0.1s;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &.letter-tile-found {
    background: rgba(0, 225, 255, 0.2);
  }
  &.letter-tile-highlighted {
    background: rgba(255, 255, 0, 0.2);
  }
  &.letter-tile-correct {
    background: rgba(0, 255, 0, 0.3) !important;
  }
}

.word-strike {
  height: 0;
  width: 100%;
  border: 1px solid #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 100;
  box-shadow: 0 0 7px #000;
  transform-origin: 0 0;

  @for $i from 0 to 7 {
    &.word-strike-direction-#{$i} {
      transform: rotate((($i * 45deg) - 90deg));
    }
  }
  @for $i from 0 to 20 {
    &:not(.word-strike-diagonal).word-strike-length-#{$i} {
      width: ($i - 1) * 100%;
    }
    &.word-strike-diagonal.word-strike-length-#{$i} {
      width: ($i - 1) * 100% * 1.414214;
    } // 1.414214 is a hypothenuse multiplier
  }
}
</style>